import { useEffect } from 'react';

import { startReportAdvocacyTracking } from '@/lib/reportAdvocacy';
import {
  startReportLinkErrorTracking,
  startReportRenderErrorTracking,
} from '@/lib/reportErrors';
import { startSectionLinkClickTracking } from '@/lib/reportLinkClicks';
import { startReportPageVisibilityTracking } from '@/lib/reportPageVisibility';
import { startReportMediaLoadErrorTracking } from '@/lib/reportMediaLoadError';
import { startReportPerformanceTracking } from '@/lib/reportPerformance';
import { startSectionViewedTracking } from '@/lib/reportSectionViewed';

type UsePostHogReportEngagementParams = {
  enabled?: boolean;
  reportId?: string | null;
  root?: ParentNode | null;
};

export const usePostHogReportEngagement = ({
  enabled = true,
  reportId,
  root,
}: UsePostHogReportEngagementParams) => {
  useEffect(() => {
    if (!enabled || !reportId || !root) return;
    const stopVisibility = startReportPageVisibilityTracking();
    const stopViewed = startSectionViewedTracking({ reportId, root });
    const stopPerformance = startReportPerformanceTracking(reportId, root);
    const stopMediaErrors = startReportMediaLoadErrorTracking(reportId, root);
    const stopLinks = startSectionLinkClickTracking({ reportId, root });
    const stopLinkErrors = startReportLinkErrorTracking(root);
    const stopAdvocacy = startReportAdvocacyTracking(reportId, root);
    const stopRenderErrors = startReportRenderErrorTracking(reportId);

    return () => {
      stopVisibility();
      stopViewed();
      stopPerformance();
      stopMediaErrors();
      stopLinks();
      stopLinkErrors();
      stopAdvocacy();
      stopRenderErrors();
    };
  }, [enabled, reportId, root]);
};
